import { RootState } from "store";

import { createSelector } from "@reduxjs/toolkit";

const selectPlaidItemIds = (state: RootState) => state.plaidItems.ids;
const selectPlaidItemsById = (state: RootState) => state.plaidItems.byId;

export const selectPlaidItems = createSelector(
  selectPlaidItemIds,
  selectPlaidItemsById,
  (plaidIds, plaidHash) => {
    return plaidIds.map(id => plaidHash[id]);
  }
);
